import DOMPurify, { type Config } from 'isomorphic-dompurify';
interface Props {
    print: string | undefined;
    stripTags?: string[];
    tag?: 'span' | 'div' | 'p';
    className?: string;
    config?: Config;
}

export default function SafeHtml({
    print = '',
    stripTags = [],
    tag = 'span',
    className,
    config = {},
}: Props): React.JSX.Element {
    const Tag = tag;

    const updatedConfig = {
        ...config,
        RETURN_DOM: false,
        RETURN_DOM_FRAGMENT: false,
    };

    let cleanHTML = DOMPurify.sanitize(print, updatedConfig) as string;

    stripTags.forEach((tag) => {
        const rx = new RegExp(`<\/?${tag}>`, 'gmi');
        cleanHTML = cleanHTML.replace(rx, '');
    });

    if (cleanHTML) {
        return <Tag className={className} dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
    }

    return <></>;
}
